export interface PayloadPayout {
    m_id?: string;
    m_transaction_id?: string;
    member_code?: string;
    m_remark?: string;
    currency_code?: string;
    amount?: number;
    customer_name?: string;
    account_name?: string;
    pay_from_bank_acc_group?: string;
    pay_from_bank_acc_code?: string;
    pay_to_acc_no?: string;
    pay_to_bank_id?: number;
    pay_to_acc_name?: string;
    pay_to_province?: string;
    pay_to_city?: string;
    pay_to_branch?: string;
    md5sig?: string;
}
